module.exports = __webpack_public_path__ + "static/img/主图.b4fe4f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/match_result/figure/结果页/爱生活/沈丞晴/主图.png
// module id = H4ux
// module chunks = 1